// Sound effects. Off by default. Toggle in user menu, on by default in TV mode.
//
// Sound files should be placed in public/sounds/. Plays gracefully degrade if files
// are missing (e.g. just a console.warn, never a thrown error).

const SOUNDS = {
  coin: '/sounds/coin.mp3',
  fanfare: '/sounds/fanfare.mp3',
  unlock: '/sounds/unlock.mp3',
  whoosh: '/sounds/whoosh.mp3',
}

const cache = new Map()

function getAudio(key) {
  if (!SOUNDS[key]) return null
  if (cache.has(key)) return cache.get(key)
  try {
    const audio = new Audio(SOUNDS[key])
    audio.preload = 'auto'
    audio.volume = 0.4
    cache.set(key, audio)
    return audio
  } catch {
    return null
  }
}

export function play(key, { force = false } = {}) {
  if (!isEnabled() && !force) return
  const audio = getAudio(key)
  if (!audio) return
  try {
    audio.currentTime = 0
    audio.play().catch(() => { /* user gesture not yet given, ignore */ })
  } catch {
    /* swallow */
  }
}

const STORAGE_KEY = 'climatise-leaderboard:sound-enabled'

export function isEnabled() {
  if (typeof window === 'undefined') return false
  try { return localStorage.getItem(STORAGE_KEY) === 'true' }
  catch { return false }
}

export function setEnabled(value) {
  try { localStorage.setItem(STORAGE_KEY, String(!!value)) }
  catch { /* ignore */ }
}

export function toggleEnabled() {
  const next = !isEnabled()
  setEnabled(next)
  return next
}
